<template lang="pug">
div
    .p-a-sm.white.lt.box-shadow
            div.pull-right.m-t-sm
                button.md-btn.md-raised.m-b-sm.w-xs.white.m-r-sm(
                    :disabled="onLoading('save-stock-return')",
                    @click="cancel",
                ) Cancel

                button.md-btn.md-raised.m-b-sm.w-xs.green(
                    :disabled="onLoading('save-stock-return')",
                    @click="submit",
                )
                    v-loading(loader="save-stock-return") Create

            nav(aria-label="breadcrumb")
                ol.breadcrumb.white.m-b-0.p-b-0
                    li.breadcrumb-item
                        router-link(to="/") Stock Return
                    li.breadcrumb-item.active Create
    .padding
        .box
            .box-header.dker
                h3 New Stock Return
            .box-divider.m-a-0
            .box-body
                .p-a
                    step-wizard

                form
                    fieldset(:disabled="onLoading('save-stock-return')")
                        .row
                            .col-md-5
                                .form-group
                                    label Return From
                                    outlet-selector(
                                        :class="{'has-error': errors.has('outlet') }"
                                        v-model="stockReturn.outlet_id",
                                        :use-vuex="false"
                                    )
                                    span.text-danger(v-if="errors.has('outlet')")
                                        | {{ errors.first('outlet') }}

                                .form-group
                                    label Supplier
                                    supplier-selector(
                                        :class="{'has-error': errors.has('supplier') }"
                                        v-model="stockReturn.supplier_id"
                                    )
                                    span.text-danger(v-if="errors.has('supplier')")
                                        | {{ errors.first('supplier') }}
</template>

<script>
import stockReturnMixin from './stock-return-mixin';
import stepWizard from './stock-return-step.vue';
import { mapActions } from 'vuex';

export default {
    $_veeValidate: {
        validator: 'new',
    },

    components: { stepWizard },

    mixins: [stockReturnMixin],

    data() {
        return {
            stockReturn: {
                outlet_id: null,
                supplier_id: null,
            },
            hasValidationError: false,
        };
    },

    methods: {
        ...mapActions('stockReturn', ['createStockReturn']),

        cancel() {
            this.$router.push('/');
        },

        async submit() {
            this.errors.clear();
            this.hasValidationError = false;

            this.validateField(this.stockReturn.outlet_id, 'outlet');
            this.validateField(this.stockReturn.supplier_id, 'supplier');

            if (this.hasValidationError) return;

            try {
                const stockReturn = await this.createStockReturn(
                    this.stockReturn,
                );
                this.$router.push(`/${stockReturn.id}`);
            } catch (e) {
                this.swalError({ text: e });
            }
        },

        validateField(value, field) {
            if (_.isNull(value) || value == 0 || String(value).trim() == '') {
                this.errors.add({
                    field: field,
                    msg: `The ${field} field is required`,
                });

                this.hasValidationError = true;

                return false;
            }

            return true;
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/stock_return/stock-return-create.vue